import { KnestPartsAPI } from './api';
export const fetchMaterials = (params = null) => {
    return KnestPartsAPI.get({
        url: `/materials`,
        params,
    });
};
